import React from 'react'
import { client } from '../../utils'
import { useStateValue } from '../state'
import AddGroupModal from './AddGroupModal'
import SaveModal from './SaveModal'
import { canvasSupportDashboard as endpoints } from '../../api_urls'
import LoadingWave from '../../components/LoadingWave'

const GroupContainerHeader = () => {
  const [currentState, dispatch] = useStateValue()

  let submitNewGroupActOrder = async () => {
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: true })
    const url = endpoints.reorderGroupsActs()
    let data = {
      nestedData: currentState.nestedGroupData,
      groups: currentState.groups,
    }
    let resp = await client.post(url, data)
    dispatch({
      type: 'UPDATE_NESTED_GROUPS',
      payload: resp.data.nestedGroupData,
    })
    dispatch({ type: 'UPDATE_GROUPS', payload: resp.data.groups })
    openCloseSaveModal()
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: false })
  }

  let [modalOpen, setModalOpen] = React.useState(false)
  let openCloseModal = () => {
    setModalOpen(!modalOpen)
  }

  let [saveModalOpen, setSaveModalOpen] = React.useState(false)
  let openCloseSaveModal = () => {
    setSaveModalOpen(!saveModalOpen)
  }

  let [newGroupName, setNewGroupName] = React.useState('New Group')
  let handleGroupNameInput = e => {
    setNewGroupName(e.target.value)
  }

  let [newGroupWeight, setNewGroupWeight] = React.useState(0.0)
  let handleWeightInput = e => {
    setNewGroupWeight(e.target.value)
  }

  const addGroup = async () => {
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: true })
    const url = endpoints.addGroup()
    let data = {
      name: newGroupName,
    }
    if (currentState.applyGroupWeights === 'true') {
      data['group_weight'] = newGroupWeight
    }
    let resp = await client.post(url, data)
    dispatch({ type: 'UPDATE_GROUPS', payload: resp.data.groups })
    dispatch({
      type: 'UPDATE_NESTED_GROUPS',
      payload: resp.data.nestedGroupData,
    })
    openCloseModal()
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: false })
  }

  let enableDisableWeights = async () => {
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: true })
    const url = endpoints.enableDisableWeights()
    let resp = await client.post(url, {
      'course[apply_assignment_group_weights]':
        currentState.applyGroupWeights === 'false',
    })
    /* dispatch({ type: 'UPDATE_GROUPS', payload: resp.data.groups }) */
    dispatch({
      type: 'ENABLE_DISABLE_WEIGHTS',
      payload: resp.data.weightsEnabled,
    })
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: false })
  }

  return (
    <div>
      <div className="d-flex justify-content-between">
        <h1 className="me-page-title">Canvas Assessments</h1>
        <div>
          <button
            className="btn btn-myed btn-default btn-default-myed mr-4 btn-sm-myed"
            onClick={openCloseSaveModal}
          >
            Save New Group and Act Order
          </button>
          <button
            className="btn btn-myed btn-default btn-default-myed mr-4 btn-sm-myed"
            onClick={openCloseModal}
          >
            <i className="fal fa-plus" /> Group
          </button>
        </div>
        <AddGroupModal
          modalOpen={modalOpen}
          openCloseModal={openCloseModal}
          handleGroupNameInput={handleGroupNameInput}
          applyGroupWeights={currentState.applyGroupWeights === 'true'}
          handleWeightInput={handleWeightInput}
          addGroup={addGroup}
        />
        <SaveModal
          modalOpen={saveModalOpen}
          openCloseModal={openCloseSaveModal}
          submitNewGroupActOrder={submitNewGroupActOrder}
        />
      </div>
      <div className="text-right mr-4">
        Group Weights Enabled
        <input
          type="checkbox"
          className="ml-3"
          checked={currentState.applyGroupWeights === 'true'}
          onChange={enableDisableWeights}
        />
      </div>
      {currentState.loading ? (
        <div className="loading-overlay d-flex justify-content-around align-items-center">
          <LoadingWave />
        </div>
      ) : null}
    </div>
  )
}

export default GroupContainerHeader
